import { validateAFM, validateEmail, validatePhoneNumber } from 'utils';

export const formFieldsLegalRepresentative = [
  {
    label: 'Επώνυμο',
    id: 'legalSurname',
    type: 'text',
    name: 'legalSurname',
    size: 'large',
    placeholder: 'Εισάγετε Επώνυμο',
    maxLength: 100,
    span: 12,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],  
  },
  {
    label: 'Όνομα',
    type: 'text',
    id: 'legalName',
    name: 'legalName',
    size: 'large',
    placeholder: 'Εισάγετε Όνομα',
    maxLength: 150,
    span: 12,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Α.Φ.Μ.',
    id: 'legalVat',
    type: 'text',
    name: 'legalVat',
    size: 'large',
    placeholder: 'Εισάγετε Α.Φ.Μ.',
    maxLength: 9,
    span: 24,
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return validateAFM(value);
        },
      }),
    ],
  },
  {
    label: 'Τηλέφωνο Επικοινωνίας',
    type: 'text',
    name: 'legalPhone',
    id: 'legalPhone',
    size: 'large',
    placeholder: 'Εισάγετε Τηλέφωνο',
    maxLength: 10,
    span: 12,
    asterisk: true,
    rules: [
      () => ({
        validator(_, value) {
          return validatePhoneNumber(value, false);
        },
      }),
    ],
  },
  {
    label: 'E-mail Επικοινωνίας',
    type: 'text',
    name: 'legalEmail',
    id: 'legalEmail',
    size: 'large',
    placeholder: 'Εισάγετε E-mail',
    maxLength: 50,
    span: 12,
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      {
        validator: (_, value) => validateEmail(value)
      }
    ],
  },
];

export const formFieldsContactPerson = [
    {
      label: 'Επώνυμο',
      type: 'text',
      name: 'contactSurname',
      id: 'contactSurname',
      size: 'large',
      placeholder: 'Εισάγετε Επώνυμο',
      maxLength: 100,
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    {
      label: 'Όνομα',
      type: 'text',
      name: 'contactName',
      id: 'contactName',
      size: 'large',
      placeholder: 'Εισάγετε Όνομα',
      maxLength: 150,
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    {
      label: 'Α.Φ.Μ.',
      type: 'text',
      name: 'contactVat',
      id: 'contactVat',
      size: 'large',
      placeholder: 'Εισάγετε Α.Φ.Μ.',
      maxLength: 9,
      span: 24,
      asterisk: true,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        () => ({
          validator(_, value) {
            return validateAFM(value);
          },
        }),
      ],
    },
    {
      label: 'Τηλέφωνο Επικοινωνίας',
      type: 'text',
      name: 'contactPhone',
      id: 'contactPhone',
      size: 'large',
      placeholder: 'Εισάγετε Τηλέφωνο',
      maxLength: 10,
      span: 12,
      asterisk: true,
      rules: [
        () => ({
          validator(_, value) {
            return validatePhoneNumber(value, false);
          },
        }),
      ],
    },
    {
      label: 'E-mail Επικοινωνίας',
      type: 'text',
      name: 'contactEmail',
      id: 'contactEmail',
      size: 'large',
      placeholder: 'Εισάγετε E-mail',
      maxLength: 50,
      span: 12,
      asterisk: true,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        {
          validator: (_, value) => validateEmail(value)
        }
      ],
    },
  ];
  

